export const SET_PEN_ID = "SET_PEN_ID";
export const SET_PEN_LOADING = "SET_PEN_LOADING" 
export const SET_SAVE_BTN_TXT = "SET_SAVE_BTN_TXT"
export const SET_FORK_BTN_TXT = "SET_FORK_BTN_TXT"
export const SET_POPUP = "SET_POPUP"



// WEBPACK FOOTER //
// ./src/redux/types/uiTypes.js